import { render, staticRenderFns } from "./BoothAdvertisingAdd.vue?vue&type=template&id=309a01b6&scoped=true"
import script from "./BoothAdvertisingAdd.vue?vue&type=script&lang=js"
export * from "./BoothAdvertisingAdd.vue?vue&type=script&lang=js"
import style0 from "./BoothAdvertisingAdd.vue?vue&type=style&index=0&id=309a01b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309a01b6",
  null
  
)

export default component.exports